module.exports = __webpack_public_path__ + "img/character-button-open.523b1a4e.png";